import { render } from "./HeaderAnalyticsPractice.vue?vue&type=template&id=8b1f073e&scoped=true"
const script = {}

import "@/css/components/header-analytics-practice.css?vue&type=style&index=0&id=8b1f073e&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b1f073e"]])

export default __exports__